<template>
  <div class="music-wrap">
    <audio
      ref="bgm"
      :src="audioSrc"
      autoplay="autoplay"
      loop="loop"
      preload="auto"
      @play="playCb"
    ></audio>
    <div class="music-btn" @click="controlMusic">
      <div class="music" :class="{ rotate: isPlayBgm }"></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "Music",
  data: () => ({
    bgm: null
  }),
 
  computed: {
    ...mapState(["isPlayBgm", "audioSrc"])
  },
  watch: {
    isPlayBgm() {
      this.isPlayBgm ? this.bgm.play() : this.bgm.pause();
    }
  },
  created () {
    document.addEventListener('click', this.playBgm)
    document.addEventListener('touchstart', this.playBgm)
    document.addEventListener('visibilitychange', this.visibilitychangeCb)
  },
  mounted () {
    this.bgm = this.$refs.bgm
  },
  methods: {
    ...mapActions(["changeIsPlayBgm", "changeIsPlayAudio"]),
    controlMusic() {
      this.changeIsPlayBgm(!this.isPlayBgm);
      this.changeIsPlayAudio(false);
    },
    playBgm(e) {
      if (e.target.className.indexOf("video-btn") < 0) {
        this.$refs.bgm && this.$refs.bgm.play();
      }
      document.removeEventListener("click", this.playBgm);
      document.removeEventListener("touchstart", this.playBgm);
    },
    playCb() {
      this.changeIsPlayBgm(true);
      document.removeEventListener("click", this.playBgm);
      document.removeEventListener("touchstart", this.playBgm);
    },
    visibilitychangeCb() {
      // 监听是否锁屏或切入后台
      if (document.hidden) {
        // 页面被挂起
        this.$refs.bgm.pause();
        this.changeIsPlayAudio(false);
      } else {
        // 页面呼出
        this.isPlayBgm && this.bgm.play();
      }
    }
  }
};
</script>
<style lang="less" scoped>
// @import "../assets/css/base.common.less";
@import "../assets/css/mixin.less";
.music-wrap {
  position: absolute;
  .mixin_com(left, 20);
  .mixin_com(top, 12);

  z-index: 2;
}
.music-btn {
  .mixin_com(width, 53);
  .mixin_com(height, 46);

  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: url("~@/assets/images/music-border.png") no-repeat left top / 100%;
  .music {
    display: block;
    content: "";
    background: url("~@/assets/images/music.png") no-repeat center center / 100%;
    .mixin_com(width, 42);
    .mixin_com(height, 42);
  }
}
.rotate {
  .animation(circle 8s infinite linear);
}
</style>
